import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DynamicFieldModel } from '@share';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { DynamicTableComponent } from 'src/app/share/dynamic-table/dynamic-table.component';
import { ItemService } from './item.service';
import { HttpParams } from '@angular/common/http';
import { LoadingService } from 'src/app/share/services/loading.service';
import { ChangeDetectorRef } from '@angular/core';
import { ItemMetricComponent } from '../item-metric/item-metric.component';
import { ItemMetricService } from '../item-metric/item-metric.service';
import { PostService } from '../post/post.service';
import { CommonModule, DatePipe } from '@angular/common';
import { forkJoin } from 'rxjs';
import { ExcelService } from 'src/app/share/services/excel.service';
@Component({
  selector: 'app-item',
  imports: [DynamicTableComponent, CommonModule],
  providers: [DatePipe, NzModalService],
  templateUrl: './item.component.html',
  styleUrl: './item.component.scss'
})
export class ItemComponent implements OnInit, AfterViewInit {
  constructor(private readonly modalService: NzModalService, private datePipe: DatePipe, private readonly postService: PostService, private readonly metricService: ItemMetricService, private service: ItemService, private loadingService: LoadingService, private cdr: ChangeDetectorRef, private readonly excelService: ExcelService) {

  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }
  ngOnInit(): void {
    forkJoin({
      groups: this.service.getGroupItems(),
      mainCategories: this.service.getMainCategoryItems(),
      categories: this.service.getCategoryItems(),
      subCategories: this.service.getSubCategoryItems(),
      groupOptions: this.postService.getGroupOption(),
      items: this.service.getItems()
    })
      .subscribe({
        next: ({ groups, mainCategories, categories, subCategories, groupOptions, items }) => {

          this.schema.columns[2].option = groups?.data.map((y: any) => ({
            text: y.group_name,
            value: y.group_name
          }));

          this.schema.columns[3].option = mainCategories?.data
            ?.filter((y: any) => y.type === 'Item')
            .map((y: any) => ({
              text: y.maincategory_name,
              value: y.maincategory_name
            }));

          this.schema.columns[4].option = categories?.data
            ?.filter((y: any) => y.type === 'Item')
            .map((y: any) => ({
              text: y.category_name,
              value: y.category_name
            }));

          this.schema.columns[5].option = subCategories?.data
            ?.filter((y: any) => y.type === 'Item')
            .map((y: any) => ({
              text: y.subcategory_name,
              value: y.subcategory_name
            }));

          this.fieldConfig[1].options = groupOptions?.map((y: any) => ({
            text: y.name,
            value: y.id
          }));
        },
        error: err => console.error('Error loading options:', err),
        complete: () => {
          let params = new HttpParams()
            .set('page', this.schema.pageIndex.toString())
            .set('pageSize', this.schema.pageSize.toString());
          this.loadData(params);
        }
      });
  }
  total: 0;
  schema = {
    name: "Item List",
    permissionKey: "item",
    enableDelete: true,
    enableEdit: true,
    enableAdd: true,
    enableDownload: false,
    size: "middle",
    pageSize: 10,
    pageIndex: 1,
    sorts: {},
    columns: [
      {
        key: "serialNo",
        title: "No",
        type: "autoGenerate",
        width: "40px",
        isStickyRight: false,
        isStickyLeft: true,

      },
      {
        key: "name",
        title: "Name",
        type: "string",
        enableSearch: true,
        searchType: "input",
        width: "300px",
        isStickyRight: false,
        isStickyLeft: true,
      },
      {
        key: "group_name",
        title: "Group Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "maincategory_name",
        title: "Main Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "category_name",
        title: "Category",
        type: "object",
        enableSearch: true,
        //enableSort:true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "subcategory_name",
        title: "Item Category Name",
        type: "string",
        enableSearch: true,
        searchType: "select",
        option: [] as any[],
        width: "260px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "price",
        title: "Highest Price",
        type: "number",
        enableSearch: true,
        //enableSort: true,
        searchType: "input",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "lowest_price",
        title: "Lowest Price",
        type: "number",
        enableSearch: true,
        //enableSort: true,
        searchType: "input",
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "status",
        title: "Status",
        type: "status",
        enableSearch: true,
        searchType: "select",
        option: [{ value: 1, text: "UnChange" }, { value: 2, text: "Up" }, { value: 3, text: "Down" }],
        width: "200px",
        isStickyRight: false,
        isStickyLeft: false,
      },
      {
        key: "action",
        title: "Actions",
        type: "button",
        width: "150px",
        isStickyRight: true,
        isStickyLeft: false,
        label: [{ name: "edit", type: "edit", isDanger: false, isEnable: true }, { name: "delete", type: "danger", isEnable: true }]
      }
    ]
  };

  report = {
    name: "Item Report",
    file_name: "Item_Report",
    header: [
      {
        label: "No",
        fieldName: "no",
        tag: "no",
        width: 5
      },
      {
        label: "Item Id",
        fieldName: "id",
        class: "align-left",
        width: 30
      },
      {
        label: "Name",
        fieldName: "name",
        class: "align-left",
        width: 30
      },
      {
        label: "Group Name",
        fieldName: "group_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Main Category Name",
        fieldName: "maincategory_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Category Name",
        fieldName: "category_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Item Category Name",
        fieldName: "subcategory_name",
        class: "align-left",
        width: 30
      },
      {
        label: "Highest Price",
        fieldName: "price",
        class: "align-left",
        width: 20
      },
      {
        label: "Lowest Price",
        fieldName: "lowest_price",
        class: "align-left",
        width: 20
      },
      {
        label: "Status",
        fieldName: "status",
        class: "align-left",
        width: 20
      },
    ]
  };

  fieldConfig: Array<DynamicFieldModel> = [
    {
      label: 'Name',
      name: 'name',
      type: 'input',
      sortOrder: 1,
      placeholder: '',
      required: true,
      autofocus: true,
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Name required',
        },
      ],
    },

    {
      label: 'Group Name',
      name: 'group_id',
      type: 'select',
      required: true,
      placeholder: 'Group Name',
      optionUrl: 'categoryhierarchy/options',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Group Name required',
        },
      ],
    },

    {
      label: 'Main Category Name',
      name: 'maincategory_id',
      type: 'select',
      required: true,
      placeholder: 'Main Category Name',
      dependOn: 'group_id',
      matchType: 'Item',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Main Category Name required',
        },
      ],
    },
    {
      label: 'Category Name',
      name: 'category_id',
      type: 'select',
      required: true,
      placeholder: 'Category Name',
      dependOn: 'maincategory_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Category Name required',
        },
      ],
    },
    {
      label: 'Item Category Name',
      name: 'subcategory_id',
      type: 'select',
      required: true,
      placeholder: 'Item Category Name',
      dependOn: 'category_id',
      optionUrl: 'categoryhierarchy/option',
      options: [
      ],
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Item Category Name required',
        },
      ],
    },
    // {
    //   label: 'Metric',
    //   name: 'itemmetric_id',
    //   type: 'select',
    //   placeholder: '',
    //   required: true,
    //   disableOnUpdate:true,
    //   validations: [
    //     {
    //       name: 'required',
    //       validator: Validators.required,
    //       message: 'Metric required',
    //     },
    //   ],
    // },

    {
      label: 'Highest Price',
      name: 'price',
      type: 'number',
      sortOrder: 2,
      class: 'col-md-6',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Highest Price required',
        },
      ],
    },
    {
      label: 'Lowest Price',
      name: 'lowest_price',
      type: 'number',
      sortOrder: 2,
      class: 'col-md-6',
      validations: [
        {
          name: 'required',
          validator: Validators.required,
          message: 'Lowest Price required',
        },
      ],
    },
    {
      label: 'id',
      name: 'id',
      type: 'hidden',
      placeholder: ''
    },
    {
      label: 'Type',
      name: 'type',
      type: 'hidden',
      value: 'Item',
    },
  ];

  list: any[] = [];
  currentTime: Date = new Date();

  getCellValue(row: any, column: any): string {
    if (column.fieldName === "eng_version") {
      if (row[column.fieldName]) {
        return 'mm , en';
      }
      else {
        return 'mm'
      }
    }
    if (!row[column.fieldName.split('.')[0]]) return ''
    const result: string = column.fieldName
      .split('.')
      .reduce((prev: any, curr: string) => prev[curr], row)
    if (column.pipe) {
      switch (column.pipe) {
        case 'shortDateTime': {
          return this.datePipe.transform(result)
        }
      }
    }

    return result
  }

  change(data: { [key: string]: any }) {
    if (data['type'] == 'download') {
      let params = new HttpParams()
        .set('filterValue', JSON.stringify(data['filters']));
      this.loadingService.toggleTableLoading()
      this.service.getItems(params).subscribe({
        next: x => {
          let data = x.data.filter((item: any) => !item.deleted);
          if (data !== undefined && data.length !== 0) {
            const value = []
            for (let i = 0; i < data?.length; i++) {
              const item: any = {}
              for (const row of this.report.header) {
                const head = row
                if (!head.hasOwnProperty('objFieldName')) {
                  if (head.tag === 'no') item[head.label] = i + 1
                  else if (head.tag === 'number')
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : 0
                  else if (head.tag === 'pipe') {
                    const [field1, field2] = head.fieldName.split('|');
                    const value = data[i][field1];
                    item[head.label] = value !== '' && value != null
                      ? value
                      : data[i][field2] ?? '';
                  }
                  else if (head.tag === 'datetime') {
                    item[head.label] = data[i][head.fieldName]
                      ? this.datePipe.transform(new Date(data[i][head.fieldName]), 'dd-MM-yyyy HH:mm')
                      : ''
                  }
                  else
                    item[head.label] = data[i][head.fieldName]
                      ? data[i][head.fieldName]
                      : ''
                } else {
                  item[head.label] =
                    data[i][head.fieldName] !== null
                      ? this.getCellValue(data[i], head)
                      : ''
                }
              }
              value.push(item)
            }
            const dynamicName = `${this.report.file_name
              }_${this.currentTime.getDate()}_${this.currentTime.getMonth() + 1
              }_${this.currentTime.getFullYear()}`;
            this.excelService.exportAsExcelFile(
              value,
              dynamicName,
              this.report.header
            )
          }
        },
        error: err => this.loadingService.toggleTableLoading(),
        complete: () => this.loadingService.toggleTableLoading()
      });
    }
    else {
      let params = new HttpParams()
        //.set('searchValue',this.searchValue)
        .set('page', data['pageIndex'].toString())
        .set('pageSize', data['pageSize'].toString())
        .set('filterValue', JSON.stringify(data['filters']))
        .set('sort', JSON.stringify(data['sorts']));

      this.loadData(params);
    }
  }

  loadData(param: HttpParams = null) {
    this.loadingService.toggleTableLoading();
    this.cdr.detectChanges();

    this.service.getItems(param).subscribe({
      next: x => {
      this.list = x.data.filter((item: any) => !item.deleted);
        this.total = x.totalCount;
      },
      error: err => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      },
      complete: () => {
        this.loadingService.toggleTableLoading();
        this.cdr.detectChanges();
      }
    });
  }

  formEvent(data: any) {
    if (data.id) {
      this.service.updateItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }
    else if (data.deleted_id) {
      data.deleted = true;
      this.modalService.confirm({
        nzTitle: 'Are you sure want to delete?',
        nzContent: 'This action cannot be undone.',
        nzOkText: 'Yes',
        nzCancelText: 'No',
        nzOnOk: () => {
          this.service.deleteItem(data).subscribe(x => {
            let params = new HttpParams()
              .set('page', this.schema.pageIndex.toString())
              .set('pageSize', this.schema.pageSize.toString());
            this.loadData(params);
          });
        },
        nzOnCancel: () => {
        }
      });
    }
    else {
      this.service.createItem(data).subscribe(x => {
        let params = new HttpParams()
          .set('page', this.schema.pageIndex.toString())
          .set('pageSize', this.schema.pageSize.toString());
        this.loadData(params);
      });
    }

  }
}
